export default __webpack_public_path__ + "static/media/inbox-cleanup.bcd0176c.svg";